import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complementos-pagos',
  templateUrl: './complementos-pagos.component.html',
  styleUrls: ['./complementos-pagos.component.scss']
})
export class ComplementosPagosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
